import React from 'react'
import { Fab, Tooltip } from '@mui/material';
import UserList from './user-list/UserList';
import AddIcon from '@mui/icons-material/Add';
import { Routes, Route, useMatch, useParams, Link } from 'react-router-dom'
import './User.scss';
import UserAdd from './user-form/user-add/UserAdd';
import UserEmptyForm from './user-form/user-empty-form/UserEmptyForm';
import UserEdit from './user-form/user-edit/UserEdit';

export default function User() {
  const match = useMatch("/#user/*");
  const path = match?.pathname || "";
  const url = match?.pathnameBase || "";

console.log('match',match);
console.log('path',path);
console.log('url',url);

    return (
        <div className="User">
            <div className="user-list">
                <UserList />
            </div>
            <div className="user-form">
                <Routes>
                    <Route path="/#user/add" element={<UserAdd />} />
                    <Route path="/#user/:id" element={<UserEdit />} />
                    <Route path="/#user" element={<UserEmptyForm />} />
                </Routes>
            </div>

            <Tooltip className="user-add-button" title="Create new user" leaveDelay={300}>
                <Fab color="secondary" component={Link} to={url + '/add'} >
                    <AddIcon />
                </Fab >
            </Tooltip>
        </div>
    )
}
